import { createComponent } from "@helpers/admin";
import FlexBoxComponent from "@template/blocks/FlexBox/component";

export const FlexBox = createComponent({
  label: "Flex Container",
  component: FlexBoxComponent,
  fields: {
    gap: {
      label: "Gap",
      type: "number",
      default: 12,
    },
    flexDirection: {
      label: "Direction",
      type: "select",
      options: [
        {
          label: "Horizontal",
          value: "row",
        },
        {
          label: "Vertical",
          value: "column",
        },
      ],
    },
    justifyContent: {
      label: "Justify Content",
      type: "select",
      options: [
        {
          label: "Start",
          value: "flex-start",
        },
        {
          label: "Center",
          value: "center",
        },
        {
          label: "End",
          value: "flex-end",
        },
        {
          label: "Space Between",
          value: "space-between",
        },
        {
          label: "Space Around",
          value: "space-around",
        },
        {
          label: "Space Evenly",
          value: "space-evenly",
        },
      ],
    },
    alignItems: {
      label: "Align Items",
      type: "select",
      options: [
        {
          label: "Start",
          value: "flex-start",
        },
        {
          label: "Center",
          value: "center",
        },
        {
          label: "End",
          value: "flex-end",
        },
        {
          label: "Stretch",
          value: "stretch",
        },
      ],
    },
    padding: {
      label: "Padding",
      type: "object",
      objectFields: {
        vertical: {
          label: "Vertical",
          type: "number",
        },
        horizontal: {
          label: "Horizontal",
          type: "number",
        },
      },
    },
    reverse: {
      label: "Reverse Order",
      type: "boolean",
    },
    flexWrap: {
      label: "Wrap",
      type: "boolean",
      default: false,
    },
    autoMaxWidth: {
      label: "Auto Max Width",
      type: "boolean",
      default: true,
    },
  },
});
